<template>
  <div>
      <el-row class="mt-2">
          <b class="text-primary">导出详细记录</b>        
      </el-row>

      <el-row class="mt-2">
          <b class="font_secondary">1. 时间</b>        
      </el-row>

      <el-row class="mt-1">
        <el-date-picker
              v-model="sdate"
              type="date"
              :value-format="df"
              placeholder="选择起始日期">
            </el-date-picker>
      </el-row>
      <el-row class="mt-2">
        <el-date-picker
              v-model="edate"
              type="date"
              :value-format="df"
              placeholder="选择结束日期">
            </el-date-picker>
      </el-row>

      <el-row class="mt-2">
          <b class="font_secondary">2. 选择单位</b>        
      </el-row>

      <el-row class="mt-2">
        <UnitCascader @onValueChanged="onUnitValueChanged"></UnitCascader>         
      </el-row>


      <el-row>
          <el-button style="margin-top: 12px;" type="primary" @click="exportExl" :loading="loading">导出</el-button>
      </el-row>
  </div>
</template>

<script>
import {exportApi} from "@/api/module/export/export";
import  {UnitCascader} from "@/views/components/select";

export default {
    name: 'exportDetail',
    components: {
      UnitCascader
    },
    data() {
      return {
        sdate: '',
        edate: '',
        unitIds: '',
        loading: false,
        df: 'yyyy-MM-dd'
      }
    },
    methods: {
      onUnitValueChanged(datas) {
        this.unitIds = datas;
      },
      exportExl() {
          this.loading = true;

          let serverUrl = "/api/manager/export/details";


          let data = {
            "sdate":this.sdate,
            "edate":this.edate,
            "unitIds":this.unitIds
          }


          let filename = "党校微课堂单位详情数据.xls";

          exportApi(data,serverUrl)
              .then((res)=>{
                let data = res.data;
                let url = window.URL.createObjectURL(new Blob([data]));
                let link = document.createElement('a');
                link.style.display = 'none';
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click()
              })
              .catch(()=>{
                this.$message.error("错误")
              })
              .finally(()=>{
                this.loading = false;
              })
              ;
        }

    }

  }

</script>


<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>